module.exports = __webpack_public_path__ + "static/img/fire_elemental.69dbc45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/fire_elemental.png
// module id = x38B
// module chunks = 0